// extracted by mini-css-extract-plugin
export default {"notes":"CompensationCard_notes__JMl02","group":"CompensationCard_group__hm8ig"};